import React,{useRef,useEffect} from 'react';

import { SketchPicker } from 'react-color';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import useStyles from './styles';

const CustomColorPicker = ({
  input,
  onClose,
  meta: { touched, error, submitFailed }
}) => {
  const classes = useStyles();

  const pickerRef = useRef(null);
  const onColorChange = color => {
    input.onChange(color);
  };

  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      onClose(false); 
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={classes.colorPickerWrapper}ref={pickerRef}>
      <IconButton className={classes.closeBtn} onClick={() => onClose(false)}>
        <HighlightOffIcon className={classes.closeIcon} />
      </IconButton>
      <SketchPicker
        color={input.value}
        onChange={color => onColorChange(color.hex)}
      />
      {(touched || submitFailed) && error && (
        <FormHelperText className={classes.errorOpenedPicker} error>
          {error}
        </FormHelperText>
      )}
    </div>
  );
};

export default CustomColorPicker;
